<footer class="pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-logo">
                        <a class="footer-logo-img" routerLink="/"><img src="assets/img/logo.png" alt="Logo" /></a>
                        <p>
                            Simple Things Make the Greatest Scenes
                        </p>
                        <ul>
                            <li>
                                <a href="https://www.facebook.com/share/14qgMUQSAZo/?mibextid=wwXIfr" target="_blank"><i
                                        class="bx bxl-facebook"></i></a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/blinkproductions_?stkn=a2M4cDNrcmo0ZWdh&utm_source=qr"
                                    target="_blank"><i class="bx bxl-instagram"></i></a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">

                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-link">
                        <h3>Useful Links</h3>

                        <ul>
                            <li><a routerLink="/">Home</a></li>
                            <li><a routerLink="/oman-fixer">Oman Fixer</a></li>
                            <li><a routerLink="/filming-in-oman">Filming in Oman</a></li>
                            <li><a routerLink="/production">Production</a></li>
                            <li><a routerLink="/behind-the-scenes">Behind the Scenes</a></li>
                            <li><a routerLink="/about-oman">About Oman</a></li>
                            <li><a routerLink="/contact">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="footer-item">
                    <div class="footer-touch">
                        <h3>Get In Touch</h3>

                        <ul>
                            <li>
                                <i class="bx bxs-phone-call"></i>
                                <h4>Mob (Oman):</h4>
                                <a href="tel:+96893656556">+96893656556</a>
                            </li>
                            <li>
                                <i class="bx bxs-phone-call"></i>
                                <h4>Mob (JOR):</h4>
                                <a href="tel:+962795222293">+962795222293</a>
                            </li>

                            <li>
                                <i class="bx bx-message-square-detail"></i>
                                <h4>Email:</h4>
                                <a href="mailto:abboud&#64;blink-productions.com">abboud&#64;blink-productions.com</a>
                            </li>
                            <li>
                                <i class="bx bxs-location-plus"></i>
                                <h4>Address:</h4>
                                <span>Muscat - Oman</span>
                            </li>
                            <li>
                                <i class="bx bx-globe"></i>
                                <h4>Website:</h4>
                                <a href="https://www.blink-production.com" target="_blank">www.blink-production.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="copyright-area">
    <div class="container">
        <div class="copyright-item">
            <p>
                © 2026, All Rights Reserved by
                <a href="http://www.blink-productions.com" target="_blank">Blink Production</a>
            </p>
        </div>
    </div>
</div>